module.exports = __webpack_public_path__ + "static/media/calculator.30ba0fe5.webp";